import Text from "_shared/text/text";

export default class FeeScheduleCategoryDescription extends Text {
  public static override fromJSON(value: string): FeeScheduleCategoryDescription {
    return new FeeScheduleCategoryDescription(value);
  }
  
  constructor(value: string) { super(value) }

  public isEqualTo = (other: Text | null | undefined): boolean => 
    other instanceof FeeScheduleCategoryDescription
    && super.isEqualTo(other)
}
